import { useEffect, useState } from "react";

import styles from "./SearchCard.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import MembersList from "../MembersList";
import { ChevronDown } from "react-ikonate";
/**
 *
 * card used on the group members tab
 */

export function SearchCard({ title, empty, iboInfos, onClick }) {
  var localIboInfos = [...iboInfos]; // so we can splice it without actually changing it
  localIboInfos.sort((a, b) => (a.iboName > b.iboName ? 1 : -1));

  const [resultsShown, setResultsShown] = useState(10);
  localIboInfos.splice(resultsShown, localIboInfos.length - resultsShown);
  const [iboInfosState, setIboInfosState] = useState(localIboInfos);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {}, [searchInput]);

  useEffect(() => {
    localIboInfos = [...iboInfos];
    localIboInfos.splice(resultsShown, localIboInfos.length - resultsShown);
    setIboInfosState(localIboInfos);
  }, [resultsShown]);

  function search() {
    var filteredResults = []; // {iboInfo, hammingDistance}
    for (var i = 0; i < iboInfos.length; i++) {
      var d = hammingDistance(
        searchInput.toLowerCase(),
        iboInfos[i].iboName.toLowerCase()
      );
      filteredResults.push({ iboInfo: iboInfos[i], hammingDistance: d });
    }

    filteredResults.sort((a, b) =>
      a.hammingDistance > b.hammingDistance ? 1 : -1
    );

    var filteredIboInfos = [];
    for (var i = 0; i < filteredResults.length && i < resultsShown; i++) {
      filteredIboInfos.push(filteredResults[i].iboInfo);
    }

    setIboInfosState(filteredIboInfos);
  }

  function hammingDistance(s, t) {
    var dist_counter = 0;
    for (var n = 0; n < s.length && n < t.length; n++) {
      if (s[n] != t[n]) {
        dist_counter++;
      }
    }
    return dist_counter;
  }

  function handleKeyDown(value) {
    if (value.key == "Enter") {
      search();
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <ChevronDown width={26} height={26} />
      </div>
      <div className={styles.header}>{title}</div>
      <div className={styles.hr} />

      <div className={styles.inputContainer}>
        <div className={styles.search} onClick={() => search()}>
          <div className={styles.circle} />
          <div className={styles.handle} />
        </div>

        <input
          type="text"
          placeholder="Search"
          value={searchInput}
          className={styles.inputField}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => handleKeyDown(e)}
        />

        <button className={styles.button} onClick={() => search()}>
          SEARCH
        </button>

        <div className={styles.view}>VIEW</div>
        <div
          className={classNames(
            styles.resultsShownButton,
            resultsShown == "10" && styles.resultsShownSelected
          )}
          onClick={() => setResultsShown("10")}
        >
          10
        </div>
        <div
          className={classNames(
            styles.resultsShownButton,
            resultsShown == "25" && styles.resultsShownSelected
          )}
          onClick={() => setResultsShown("25")}
        >
          25
        </div>
        <div
          className={classNames(
            styles.resultsShownButton,
            resultsShown == "50" && styles.resultsShownSelected
          )}
          onClick={() => setResultsShown("50")}
        >
          50
        </div>
        <div
          className={classNames(
            styles.resultsShownButton,
            resultsShown == "ALL" && styles.resultsShownSelected
          )}
          onClick={() => setResultsShown("ALL")}
        >
          ALL
        </div>
      </div>

      <MembersList members={iboInfosState} empty={empty} />
    </div>
  );
}

SearchCard.propTypes = {
  onClick: PropTypes.func,
  iboInfos: PropTypes.arrayOf(PropTypes.object),
};
